import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix
import { devConfig, profile } from 'config/config'; // Importing development configuration and user profile

/**
 * Class representing the FilterBonusReportView.
 * @extends JetView
 */
export default class FilterBonusReportView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration
        const left = {
            // Left section of the form
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect', // Dropdown for selecting result date type
                    name: 'ResultDate',
                    localId: 'timeTypes:combo',
                    label: _('Tipo de tiempo'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [], // Options will be populated dynamically
                },
                {
                    view: 'richselect', // Dropdown for selecting bonus type
                    name: 'BonusType',
                    localId: 'bonusTypes:combo',
                    label: _('Tipo'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [], // Options will be populated dynamically
                },
            ],
        };
        const center_left = {
            // Center-left section of the form
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for date range
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange',
                    readonly: true,
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Localized label with icon
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                },
                {
                    view: 'datepicker', // Datepicker for selecting a date
                    name: 'Date',
                    id: 'Date',
                    stringResult: true,
                    minWidth: 200,
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Localized label with icon
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    value: moment().format('YYYY-MM-DD'), // Default value set to today's date
                    format: '%d %M %Y', // Date format
                    suggest: {
                        type: 'calendar',
                        body: {
                            maxDate: new Date(), // Maximum date is today
                        },
                    },
                },
                {
                    view: 'richselect', // Dropdown for selecting acceptance type
                    name: 'AcceptanceType',
                    localId: 'bonusStates:combo',
                    label: _('Estado'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [], // Options will be populated dynamically
                },
            ],
        };
        const center_right = {
            // Center-right section of the form
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for partner bonus ID
                    name: 'ClientBonusId',
                    label: _('Partner Bono Id'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Partner Bono Id'),
                    invalidMessage: _('Partner Bonus Id is required'), // Validation message
                },
            ],
        };
        const right = {
            // Right section of the form
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for ID
                    name: 'PartnerBonusId',
                    label: _("<span class='icon-id'></span> ID"), // Localized label with icon
                    labelPosition: 'top',
                    placeholder: _('ID'),
                    invalidMessage: _('ID is required'), // Validation message
                },
            ],
        };
        const upper_section = {
            // Upper section containing all form parts
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right, right], // Layout of columns
                },
            ],
        };
        const buttons = {
            // Button section for actions
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'), // Localized label
                    autowidth: true,
                    click: () => {
                        // Clear form values on click
                        this.getRoot().clear();
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'), // Localized label
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        // Handle form submission on click
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove datepicker if typeDate is 2
                            }
                        }
                        this.app.callEvent('bonusReport:filter', [filterdata]); // Trigger filter event
                    },
                },
            ],
        };
        return {
            // Return the complete form configuration
            view: 'form',
            scroll: 'y',
            rows: [upper_section, buttons],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        webix.ready(function () {
            // Wait for webix to be ready
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide date input if typeDate is not 2
                $$('Datepicker').show(); // Show datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show date input if typeDate is 2
                    $$('Datepicker').hide(); // Hide datepicker
                }
            }
        });
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            // Attach event after rendering datepicker
            devConfig.setDateModal(lang); // Set date modal configuration based on language
        });
    }
}

// FILE DOCUMENTED
